import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  Button,
  Box,
  Dialog,
  DialogContent,
  CircularProgress,
} from "@mui/material";

const ActiveImage = () => {
  const [currentPages, setCurrentPages] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    axios
      .get(`/api/v1/images`, {
        params: {
          page: currentPages,
          limit: 21,
          isHome: 1,
        },
      })
      .then((res) => {
        setData(res.data.images);
        setTotalPages(res.data.totalPages);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  };

  const handleViewMore = () => {
    setLoading(true);
    setCurrentPages(currentPages + 1);
    axios
      .get(`/api/v1/images`, {
        params: {
          page: currentPages + 1,
          limit: 21,
          isHome: 1,
        },
      })
      .then((res) => {
        setData((prevData) => [...prevData, ...res.data.images]);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  };

  const handleImageClick = (imagePath) => {
    setSelectedImage(imagePath);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImage(null);
  };

  return (
    <>
      <div className="login-signup-container mt-4">
        <div className="active-image-title">Hình ảnh hoạt động</div>
        <div className="active-image-layout">
          <div className="active-image-content">
            {data.map((item, idx) => (
              <Box
                onClick={() => handleImageClick(item.path)}
                key={idx}
                component="img"
                src={item.path}
                alt=""
                sx={{
                  width: 150,
                  height: 150,
                  minWidth: 150,
                  maxHeight: 150,
                  objectFit: "cover",
                  borderRadius: 1,
                  overflow: "hidden",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  "&:hover": {
                    transform: "scale(1.1)",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
                  },
                }}
              />
            ))}
          </div>
          {currentPages < totalPages && (
            <div className="news-layout-view-more">
              <Button
                variant="contained"
                size="large"
                onClick={handleViewMore}
                sx={{ pl: 5, pr: 5, backgroundColor: "#0148b7" }}
              >
                Xem thêm
              </Button>
            </div>
          )}
        </div>
        <Dialog open={open} onClose={handleClose} maxWidth="sm">
          <DialogContent sx={{ padding: 0 }}>
            <Box
              component="img"
              src={selectedImage}
              alt=""
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          </DialogContent>
        </Dialog>
        {loading && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.2)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1300,
            }}
          >
            <CircularProgress sx={{ color: "#0184b7" }} />
          </Box>
        )}
      </div>
    </>
  );
};

export default ActiveImage;
